// extracted by mini-css-extract-plugin
module.exports = {"InlineInput":"UploadWidget_InlineInput__1JJ5A","InlineButton":"UploadWidget_InlineButton__19_Av"};